import { render, staticRenderFns } from "./intro.vue?vue&type=template&id=21b5f3a3&scoped=true"
import script from "./intro.vue?vue&type=script&lang=js"
export * from "./intro.vue?vue&type=script&lang=js"
import style0 from "./intro.vue?vue&type=style&index=0&id=21b5f3a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b5f3a3",
  null
  
)

export default component.exports